// extracted by mini-css-extract-plugin
module.exports = {"optionImage":"AncillaryDataSelect_optionImage__1GgVu","optionLabel":"AncillaryDataSelect_optionLabel__1AQLT"};